export const colors = {
    gray: 'var(--ion-color-tertiary)',
    blue: 'var(--ion-color-quaternary)',
    green: 'var(--ion-color-secondary)',
    gold: 'var(--ion-color-primary)',
};
